import axios from "axios";

const api = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/datalab`,
    withCredentials: true,
});

export const fetchDataLabStatus = () => api.get("/status").then((r) => r.data);
export const probeDataLabStorage = () => api.post("/storage/probe").then((r) => r.data);
export const fetchDataLabJobs = () => api.get("/jobs").then((r) => r.data);
export const fetchDataLabArchives = () => api.get("/archives").then((r) => r.data);
export const createDataLabJob = (payload) => api.post("/jobs", payload).then((r) => r.data);
export const cancelDataLabJob = (id) => api.post(`/jobs/${id}/cancel`).then((r) => r.data);
export const verifyDataLabArchive = (id) => api.post(`/archives/${id}/verify`).then((r) => r.data);
export const deleteDataLabArchive = (id) => api.delete(`/archives/${id}`).then((r) => r.data);
export const replayDataLabArchive = (id, params = {}) => api.get(`/archives/${id}/replay`, { params }).then((r) => r.data);
export const dataLabExportUrl = (id, format) => `${process.env.REACT_APP_BACKEND_URL}/api/datalab/archives/${id}/export?format=${format}`;
